import DatabaseModel from './DatabaseModel.js';
import UsuarioCliente from './UsuarioCliente.js';
import Inspector from './Inspector.js';

var Usuario = Object.create(DatabaseModel);

Usuario.model = 'user';

Usuario.getList = function(params) {
    var self = this;
    params = params || {};
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server + 'security/' + self.model + '/SIMECAL_MOVILIDAD',
            method: 'GET',
            contentType: 'application/json',
            dataType: 'json',
            crossDomain: true
        }).then(function({ data, xhr, status }) {
            if (data.error) {
                reject(data);
            } else {
                resolve(data);
            }
        }).catch(function({ xhr, status, message }) {
            try {
                reject(JSON.parse(xhr.response).error);
            } catch (e) {
                reject(xhr.response);
            }
        });
    });
};

Usuario.get = function(params) {
    var self = this;
    return new Promise(function(resolve, reject) {
        if (!params.itemId) reject({ error: 'itemId not defined' });
        self.request.promise({
            url: self.server + 'security/' + self.model + '/SIMECAL_MOVILIDAD/' + params.itemId + '/',
            method: 'GET',
            contentType: 'application/json',
            dataType: 'json',
            crossDomain: true,
            data: {}
        }).then(function({ data, xhr, status }) {
            if (data.error) {
                reject(data);
            } else {
                resolve(data.dto);
            }
        }).catch(function({ xhr, status, message }) {
            try {
                reject(JSON.parse(xhr.response).error);
            } catch (e) {
                reject(xhr.response);
            }
        });
    });
};

Usuario.save = function(params) {
    var self = this;
    if (params.itemId) {
        return self.put(params);
    } else {
        return self.post(params);
    }
}

Usuario.put = function(params) {
    var self = this;
    return new Promise(function(resolve, reject) {
        if (!params.itemId) reject({ error: 'itemId not defined' });
        self.request.promise({
            url: self.server + 'security/' + self.model + '/SIMECAL_MOVILIDAD/' + params.itemId + '/',
            method: 'PUT',
            contentType: 'application/json',
            dataType: 'json',
            crossDomain: true,
            data: params.data
        }).then(function({ data, xhr, status }) {
            if (data.error) {
                reject(data);
            } else {
                resolve(data.dto);
            }
        }).catch(function({ xhr, status, message }) {
            try {
                reject(JSON.parse(xhr.response).error);
            } catch (e) {
                reject(xhr.response);
            }
        });
    });
}

Usuario.post = function(params) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server + 'security/' + self.model + '/SIMECAL_MOVILIDAD/',
            method: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            crossDomain: true,
            data: params.data
        }).then(function({ data, xhr, status }) {
            if (data.error) {
                reject(data);
            } else {
                resolve(data.dto);
            }
        }).catch(function({ xhr, status, message }) {
            try {
                reject(JSON.parse(xhr.response).error);
            } catch (e) {
                reject(xhr.response);
            }
        });
    });
}

Usuario.delete = function(params) {
    var self = this;
    return new Promise(function(resolve, reject) {
        if (!params.itemId) reject({ error: 'itemId not defined' });
        self.request.promise({
            url: self.server + 'security/' + self.model + '/SIMECAL_MOVILIDAD/' + params.itemId + '/',
            method: 'DELETE',
            contentType: 'application/json',
            dataType: 'json',
            crossDomain: true,
            data: params.data
        }).then(function({ data, xhr, status }) {
            if (data.error) {
                reject(data);
            } else {
                if (data.dto && data.dto.application && data.dto.application.roles && (data.dto.application.roles.indexOf('CLIENTE') > -1 || data.dto.application.roles.indexOf('ADMINISTRATIVO') > -1)) {
                    UsuarioCliente.delete({ itemId: data.dto.username })
                } else if (data.dto && data.dto.application && data.dto.application.roles && data.dto.application.roles.indexOf('INSPECTOR') > -1) {
                    Inspector.delete({ itemId: data.dto.username })
                }
                resolve(data.dto);
            }
        }).catch(function({ xhr, status, message }) {
            try {
                reject(JSON.parse(xhr.response).error);
            } catch (e) {
                reject(xhr.response);
            }
        });
    });
}

Usuario.auth = function(params) {
    var self = this;
    //params.username = 'USER_INSPECCIONES_ADMIN';
    //params.password = 'ADMIN';
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server + 'security/oauth/token',
            method: 'POST',
            contentType: 'application/x-www-form-urlencoded',
            dataType: 'json',
            crossDomain: true,
            headers: {
                'Authorization': 'Basic ' + btoa(self.client_id + ":" + self.client_secret)
            },
            data: {
                grant_type: 'password',
                username: params.username,
                password: params.password
            }
        }).then(function({ data, xhr, status }) {
            if (data.error) {
                reject(data);
            } else {
                resolve(data);
            }

        }).catch(function({ xhr, status, message }) {
            try {
                reject(JSON.parse(xhr.response));
            } catch (e) {
                reject(xhr.response);
            }
        });

    });
};

Usuario.me = function(params) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + 'me',
            method: 'GET',
            contentType: 'application/json',
            dataType: 'json',
            crossDomain: true
        }).then(function({ data, xhr, status }) {
            if (data.error) {
                reject(data);
            } else {
                resolve(data.dto);
            }
        }).catch(function({ xhr, status, message }) {
            // [#65] El código HTTP viaja con el error. `me` no pasa por `DatabaseModel.sendRequest`,
            // así que nadie más lo va a mirar, y quien la llama necesita distinguir «el token ya no
            // vale» —que cierra la sesión— de «el servidor ha fallado» —que se reintenta—.
            var cuerpo = null;
            try {
                cuerpo = JSON.parse(xhr.response);
            } catch (e) {
                cuerpo = null;
            }
            if (cuerpo && typeof cuerpo == 'object') {
                cuerpo.status = status;
                reject(cuerpo);
            } else {
                reject({ status: status, error: xhr.response, message: message });
            }
        });
    });
};

Usuario.cambiarPass = function(params) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server + 'security/' + self.model + '/change_password',
            method: 'PUT',
            contentType: 'application/json',
            dataType: 'json',
            crossDomain: true,
            data: params
        }).then(function({ data, xhr, status }) {
            if (data.error) {
                reject(data);
            } else {
                resolve(data);
            }

        }).catch(function({ xhr, status, message }) {
            try {
                reject(JSON.parse(xhr.response));
            } catch (e) {
                reject(xhr.response);
            }
        });

    });
};

Usuario.resetPass = function(params) {
    var self = this;
    if (!params.itemId) reject({ error: 'itemId not defined' });
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server + 'security/' + self.model + '/reset_password/' + params.itemId,
            method: 'PUT',
            contentType: 'application/json',
            dataType: 'json',
            crossDomain: true
        }).then(function({ data, xhr, status }) {
            if (data.error) {
                reject(data);
            } else {
                resolve(data);
            }

        }).catch(function({ xhr, status, message }) {
            try {
                reject(JSON.parse(xhr.response));
            } catch (e) {
                reject(xhr.response);
            }
        });

    });
};

export default Usuario;